module.exports = __webpack_public_path__ + "img/Youtube_black.b26edf40.svg";